import { createFileRoute } from '@tanstack/react-router'
import SignInForm from "@/components/auth/SignInForm";

function PlatformSignIn() {
  return <SignInForm expectedTier="platform" />;
}

export const Route = createFileRoute('/(authentication)/(auth)/platform/signin/')({
  component: PlatformSignIn,
})
